module.exports = __webpack_public_path__ + "static/Marco-Bizzantino-5136abafa907d302188810bf102e05ee.jpg";